module.exports = __webpack_public_path__ + "img/loading_new.gif";